import {useTranslation} from "react-i18next";
import {useMutation} from "@tanstack/react-query";
import {useToast} from "../context/toast";
import axiosManager from "../services/axiosManager";

export const useApplicationSubmit = (applicationId) => {
    const {t} = useTranslation();
    const toast = useToast();

    const {
        mutateAsync: submitApplication, isPending: isSubmittingApplication,
    } = useMutation({
        mutationFn: () => axiosManager.post$(`applications/${applicationId}/submit`).then((response) => response?.data),
        onError: () => {
            toast.error(t("errors.common"));
        },
    });

    return {
        submitApplication,
        isSubmittingApplication,
    };
};
